module.exports = __webpack_public_path__ + "img/16.d357ac17.jpg";